const initialState = {
  submitFile: null,
  submitClients: [],
  manualClients: [],
  columns: [
    { key: 'nome', label: 'Nome', sortable: true, value: null },
    { key: 'email', label: 'E-mail', sortable: true, value: null },
    { key: 'telefone', label: 'Telefone', sortable: true, value: null },
  ],
};

export default initialState;



// WEBPACK FOOTER //
// ./src/store/modules/submit/initialState.js